import { render, staticRenderFns } from "./JournalChapter.vue?vue&type=template&id=118d3c46&"
import script from "./JournalChapter.vue?vue&type=script&lang=js&"
export * from "./JournalChapter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\soiko\\Documents\\Projects\\game\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('118d3c46')) {
      api.createRecord('118d3c46', component.options)
    } else {
      api.reload('118d3c46', component.options)
    }
    module.hot.accept("./JournalChapter.vue?vue&type=template&id=118d3c46&", function () {
      api.rerender('118d3c46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/JournalChapter.vue"
export default component.exports